import React, { useState, useRef, useEffect } from 'react';
import { Input } from '@/components/ui/input';

const DOMINIOS = [
  'gmail.com',
  'hotmail.com',
  'outlook.com',
  'yahoo.com.br',
  'yahoo.com',
  'live.com',
  'icloud.com',
  'terra.com.br',
  'uol.com.br',
  'bol.com.br',
  'globo.com',
  'ig.com.br',
  'msn.com',
  'oi.com.br',
  'r7.com',
  'zipmail.com.br',
];

const EmailSugestao = ({ value, onChange, onBlur, className, ...props }) => {
  const [sugestoes, setSugestoes] = useState([]);
  const [selecionado, setSelecionado] = useState(-1);
  const [aberto, setAberto] = useState(false);
  const wrapperRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const handleClickFora = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setAberto(false);
      }
    };
    document.addEventListener('mousedown', handleClickFora);
    return () => document.removeEventListener('mousedown', handleClickFora);
  }, []);

  const handleChange = (e) => {
    const val = e.target.value.toLowerCase();
    onChange(val);

    const atIndex = val.lastIndexOf('@');
    if (atIndex > 0) {
      const parteDepois = val.slice(atIndex + 1);
      if (parteDepois.length === 0) {
        setSugestoes(DOMINIOS.map(d => val.slice(0, atIndex + 1) + d));
        setAberto(true);
      } else {
        const filtrados = DOMINIOS
          .filter(d => d.startsWith(parteDepois) && d !== parteDepois)
          .map(d => val.slice(0, atIndex + 1) + d);
        setSugestoes(filtrados);
        setAberto(filtrados.length > 0);
      }
    } else {
      setSugestoes([]);
      setAberto(false);
    }
    setSelecionado(-1);
  };

  const handleKeyDown = (e) => {
    if (!aberto || sugestoes.length === 0) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setSelecionado(prev => (prev < sugestoes.length - 1 ? prev + 1 : 0));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setSelecionado(prev => (prev > 0 ? prev - 1 : sugestoes.length - 1));
    } else if ((e.key === 'Enter' || e.key === 'Tab') && selecionado >= 0) {
      e.preventDefault();
      selecionarSugestao(sugestoes[selecionado]);
    } else if (e.key === 'Escape') {
      setAberto(false);
    }
  };

  const selecionarSugestao = (email) => {
    onChange(email);
    setAberto(false);
    setSugestoes([]);
    setSelecionado(-1);
    inputRef.current?.focus();
  };

  return (
    <div ref={wrapperRef} className="relative">
      <Input
        ref={inputRef}
        type="email"
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onBlur={(e) => {
          setTimeout(() => setAberto(false), 150);
          if (onBlur) onBlur(e);
        }}
        onFocus={() => {
          if (sugestoes.length > 0) setAberto(true);
        }}
        autoComplete="off"
        className={className}
        {...props}
      />
      {aberto && sugestoes.length > 0 && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto">
          {sugestoes.map((s, i) => {
            const atIdx = s.indexOf('@');
            const antes = s.slice(0, atIdx);
            const dominio = s.slice(atIdx);
            return (
              <button
                key={s}
                type="button"
                onMouseDown={(e) => { e.preventDefault(); selecionarSugestao(s); }}
                className={`w-full text-left px-3 py-2 text-sm transition-colors flex items-center ${
                  i === selecionado
                    ? 'bg-red-50 text-red-700'
                    : 'hover:bg-gray-50 text-gray-700'
                }`}
                data-testid={`email-sugestao-${i}`}
              >
                <span>{antes}</span>
                <span className="font-semibold text-red-600">{dominio}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default EmailSugestao;
